import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { CheckCircleIcon } from '@heroicons/react/24/outline';

const PaymentSuccess: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { teamName, licenseType } = location.state || {};

    const handleContinue = () => {
        navigate('/teams');
    };

    return (
        <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
            <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
                <div className="bg-white dark:bg-gray-800 py-8 px-4 shadow sm:rounded-lg sm:px-10">
                    <div className="text-center">
                        <CheckCircleIcon className="mx-auto h-12 w-12 text-green-500" />
                        <h2 className="mt-6 text-2xl font-bold text-gray-900 dark:text-white">
                            Payment Successful!
                        </h2>
                        <p className="mt-2 text-sm text-gray-600 dark:text-gray-300">
                            Thank you for your purchase. Your license has been upgraded.
                        </p>
                        {/* {teamName && (
                            <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
                                Team: {teamName}
                            </p>
                        )} */}
                        {/* {licenseType && (
                            <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
                                License: {licenseType}
                            </p>
                        )} */}
                    </div>

                    <div className="mt-6">
                        <button
                            onClick={handleContinue}
                            className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                        >
                            Continue
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PaymentSuccess; 